import { useMemo } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import UeberUnsHero from './components/UeberUnsHero';
import FacilitySparten from './components/FacilitySparten';
import GruenderSpotlight from './components/GruenderSpotlight';
import FirmengeschichteTimeline from './components/FirmengeschichteTimeline';
import TeamSection from './components/TeamSection';
import KernwerteSection from './components/KernwerteSection';
import UeberUnsCTA from './components/UeberUnsCTA';
import SEO from '../../components/feature/SEO';
import JsonLd from '../../components/feature/JsonLd';

export default function UeberUnsPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://igm-baudienste.com';

  const jsonLdData = useMemo(() => ({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        '@id': `${siteUrl}/ueber-uns`,
        'url': `${siteUrl}/ueber-uns`,
        'name': 'Über uns | IGM Facility Service – Team & Geschichte Ratingen',
        'description': 'Erfahren Sie mehr über IGM Facility Service: unser Team, unsere Geschichte und die Werte, die uns antreiben. Ihr zuverlässiger Facility-Partner in Ratingen.',
        'isPartOf': { '@id': `${siteUrl}/#website` },
        'about': { '@id': `${siteUrl}/#business` },
      },
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#business`,
        'name': 'IGM Facility Service',
        'url': siteUrl,
        'foundingDate': '2010',
        'founder': {
          '@type': 'Person',
          'name': 'Ilker Sahin',
        },
        'address': {
          '@type': 'PostalAddress',
          'streetAddress': 'Industriestr. 37',
          'addressLocality': 'Ratingen',
          'postalCode': '40878',
          'addressCountry': 'DE',
        },
        'contactPoint': {
          '@type': 'ContactPoint',
          'telephone': '+4921027398070',
          'contactType': 'customer service',
          'areaServed': 'DE',
          'availableLanguage': 'German',
        },
      },
    ],
  }), [siteUrl]);

  const breadcrumbData = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Home',
        'item': siteUrl,
      },
      {
        '@type': 'ListItem',
        'position': 2,
        'name': '\u00dcber uns',
        'item': `${siteUrl}/ueber-uns`,
      },
    ],
  }), [siteUrl]);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Über uns | IGM Facility Service – Team & Geschichte Ratingen"
        description="Erfahren Sie mehr über IGM Facility Service: unser Team, unsere Geschichte und die Werte, die uns antreiben. Ihr zuverlässiger Facility-Partner in Ratingen seit Jahren."
        keywords="IGM Facility Service Team, Unternehmensgeschichte Ratingen, Facility Management NRW"
        canonical={`${siteUrl}/ueber-uns`}
      />
      <JsonLd data={jsonLdData} id="json-ld-ueber-uns" />
      <JsonLd data={breadcrumbData} id="json-ld-ueber-uns-breadcrumb" />
      <Navbar />
      <main>
        <UeberUnsHero />
        <FacilitySparten />
        <GruenderSpotlight />
        <FirmengeschichteTimeline />
        <TeamSection />
        <KernwerteSection />
        <UeberUnsCTA />
      </main>
      <Footer />
    </div>
  );
}
